// import { bootstrapApplication } from '@angular/platform-browser';
// import { appConfig } from './app/app.config';
// import { AppComponent } from './app/app.component';
//
// bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// The @sentry/angular package had been a dependency for a long time without
// ever being initialised, so the backoffice reported nothing at all.
//
// Error monitoring only: Tracing, Session Replay and Logs are not enabled on
// the Sentry plan, and Session Replay on an admin console would record other
// people's personal data. Do not add integrations here without deciding that
// separately.
//
// An empty dsn disables the SDK, which is how local development stays silent.
Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.production ? 'production' : 'development',
  tracesSampleRate: 0,
});
// import { environment } from './environments/environment';
//
// if (environment.production) {
//   enableProdMode();
// }

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
